import React from "react"

interface PoweredByFiderProps {
  slot: string
  className?: string
}

// Tùy biến KHCN: ẩn dòng "Powered by Fider" nhưng giữ props để các trang gọi không phải sửa
export const PoweredByFider: React.FC<PoweredByFiderProps> = () => {
  return null
}
